import { QueryClientProvider } from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router/dom';
import { UploadsProvider } from '../features/studio/upload/UploadsContext.tsx';
import { ApiProvider } from '../shared/api/ApiContext.tsx';
import { Toaster, TooltipProvider } from '../shared/ui/index.ts';
import type { AppServices } from './composition.ts';

export const App = ({ services }: { readonly services: AppServices }) => (
  <I18nextProvider i18n={services.i18n}>
    <QueryClientProvider client={services.queryClient}>
      <ApiProvider client={services.api}>
        <UploadsProvider manager={services.uploads}>
          <TooltipProvider>
            <RouterProvider router={services.router} />
            <Toaster />
          </TooltipProvider>
        </UploadsProvider>
      </ApiProvider>
    </QueryClientProvider>
  </I18nextProvider>
);
